import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import KivaProxy from "@/utils/kivaProxy/src/index";
import optionsMixin from "@/mixins/options";
export default {
  mixins: [optionsMixin],
  props: {
    account: Object,
    view: {
      type: String,
      default: "light"
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    view: function view(val) {
      this.getData();
    }
  },
  data: function data() {
    return {
      accountId: this.account.record_id,
      items: [],
      loading: false,
      searchKeyword: ""
    };
  },
  methods: {
    setView: function setView(val) {
      this.$emit("setView", val);
    },
    callPhone: function callPhone(val) {
      window.open("tel:" + val);
    },
    editData: function editData(id) {
      this.$store.state.app.templatePopup.data = {
        record_id: id,
        model: "project",
        openSearchBox: false
      };
      this.$store.state.app.templatePopup.show = true;
    },
    getData: function getData() {
      var _this2 = this;
      this.loading = true;
      var filter = {
        account_name: ["=", this.accountId]
      };
      var keyword = "";
      if (this.searchKeyword) {
        keyword = this.searchKeyword;
      }
      new KivaProxy({
        endpoint: "act/project"
      }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_color", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "use_threads", "approval_required", "use_sections", "section_required", "time"]).setFilters(filter).setKeyword(keyword).all().then(function (response) {
        _this2.items = response.records;
        var total = response.total;
        if (_this2.view == "light") {
          _this2.$emit("setTotal", total);
        }
        _this2.loading = false;
      }).catch(function (err) {
        console.log("err", err);
      });
    }
  }
};